import { render, staticRenderFns } from "./recomment_tabInfo.vue?vue&type=template&id=6da97226&scoped=true&"
import script from "./recomment_tabInfo.vue?vue&type=script&lang=js&"
export * from "./recomment_tabInfo.vue?vue&type=script&lang=js&"
import style0 from "./recomment_tabInfo.vue?vue&type=style&index=0&id=6da97226&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da97226",
  null
  
)

export default component.exports